import { CheckmarkOrb } from '@clearkit/icons';
import { CKBannerNext, CKLayoutGridAuto, CKLayoutVertical } from 'clearkit';

import { useCreditUsage } from '~/hooks/account/useCreditUsage';

import { routes } from '../app/appMainRoutes';
import { BusinessPlan, FreePlan, GrowthPlan } from '../PlanColumns';

const PlansAndBilling = () => {
  const { isPaidAccount, credits } = useCreditUsage();

  return (
    <div className="space-y-8 max-w-[60rem]">
      {isPaidAccount ? (
        <CKBannerNext>
          <CKBannerNext.IconStatus>
            <CheckmarkOrb />
          </CKBannerNext.IconStatus>
          <CKBannerNext.Body>
            <CKLayoutVertical as="span" gap="0">
              <span className="font-semibold text-gray-900">
                Your team has been upgraded to the Growth plan
              </span>
              <span className="text-gray-500">
                {credits} credits available per month, refreshed monthly
              </span>
            </CKLayoutVertical>
          </CKBannerNext.Body>
        </CKBannerNext>
      ) : null}
      <CKLayoutGridAuto
        autoRepeat="auto-fit"
        gapColumn="2rem"
        gapRow="4rem"
        minWidth="15rem"
      >
        <FreePlan />
        <GrowthPlan url={routes.plansUpgrade} />
        <BusinessPlan />
      </CKLayoutGridAuto>
    </div>
  );
};

export default PlansAndBilling;
